export const commonPrintColumnChartFontData = {
    xAxis: '1.5vw',
    yAxis: '2.3vmin',
    percentNum: '2.4vmin',
    radarChartText: '3.1vmin',
    fontWeight: 550,
};
